import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import toast from 'react-hot-toast';

export default function CustomerLogin() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const handle = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.email, form.password);
      nav('/cliente/home');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Erro ao entrar');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="screen bg-white flex flex-col">
      <div className="gradient-hero px-6 pt-10 pb-12 text-white relative overflow-hidden">
        <div className="absolute inset-0 bg-dots opacity-40 pointer-events-none" />
        <div className="relative">
          <div className="flex justify-center mb-2">
            <img
              src="/logo.png"
              alt="GasNaPorta"
              className="w-72 max-w-full h-auto object-contain logo-glow float-soft"
            />
          </div>
          <div className="text-center">
            <span className="inline-block text-[11px] uppercase tracking-[0.35em] text-sky-200 font-black px-4 py-1.5 rounded-full glass-light">
              Cliente
            </span>
          </div>
          <h1 className="text-xl font-black text-center mt-5 text-white">Entrar na sua conta</h1>
          <p className="text-sky-200 text-sm mt-1 text-center">Peça seu gás com rapidez</p>
        </div>
      </div>

      <form onSubmit={handle} className="flex-1 px-6 py-8 space-y-4">
        <div>
          <label className="block text-sm font-semibold text-gray-600 mb-1">Email</label>
          <input
            type="email"
            required
            value={form.email}
            onChange={e => setForm(p => ({ ...p, email: e.target.value }))}
            className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-primary"
            placeholder="seu@email.com"
          />
        </div>
        <div>
          <label className="block text-sm font-semibold text-gray-600 mb-1">Senha</label>
          <input
            type="password"
            required
            value={form.password}
            onChange={e => setForm(p => ({ ...p, password: e.target.value }))}
            className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-primary"
            placeholder="••••••••"
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          className="w-full py-4 bg-primary hover:bg-primary-dark disabled:opacity-60 rounded-2xl font-bold text-white text-lg mt-2 transition-all active:scale-95"
        >
          {loading ? 'Entrando...' : 'Entrar'}
        </button>

        <p className="text-center text-sm text-gray-500">
          Não tem conta?{' '}
          <Link to="/cliente/cadastro" className="text-primary font-bold">Cadastre-se</Link>
        </p>
      </form>
    </div>
  );
}
